import React, { useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewer = ({ pdfUrl }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  return (
    <div style={{ height: "150vh" }}>
      {/* Worker para cargar PDFs */}
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Viewer
          fileUrl={pdfUrl} // Archivo PDF
          plugins={[defaultLayoutPluginInstance]} // Activar el índice
          defaultScale={isMobile? 0.6: 1.2} // Zoom inicial (120%)
        />
      </Worker>
    </div>
  );
};

export default PdfViewer;
